import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconSvg } from '@prism/icon';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["color", "type", "label", "selected", "selectable", "actionable", "removeable", "transparent", "iconBefore", "iconAfter", "bold", "uppercase", "href"];

var makeIcon = function makeIcon(_ref) {
  var glyph = _ref.glyph,
      color = _ref.color,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align;
  if (!glyph) return null;
  var args = {
    glyph: glyph,
    color: color === 'dark' ? '#fff' : '#4a4a4a',
    height: '10px',
    className: "icon prism-icon-".concat(glyph, " chip-icon-").concat(align)
  };
  return /*#__PURE__*/React.createElement(IconSvg, args);
};

function useChip(props) {
  var color = props.color,
      type = props.type;
      props.label;
      props.selected;
      props.selectable;
      props.actionable;
      props.removeable;
      props.transparent;
      var iconBefore = props.iconBefore,
      iconAfter = props.iconAfter;
      props.bold;
      props.uppercase;
      props.href;
      var extraProps = _objectWithoutProperties(props, _excluded);

  var flags = {
    isAction: type === 'action',
    isFilter: type === 'filter',
    isSelectable: type === 'select',
    isTransparent: props.transparent,
    isBold: props.bold,
    isSelected: props.selected,
    isUppercase: props.uppercase,
    isCross: !iconAfter && type === 'filter',
    hasIcon: iconBefore || iconAfter
  };
  var className = classnames('chip', "chip-".concat(color), {
    'chip-transparent': props.transparent
  }, {
    'chip-actionable': type === 'action'
  }, {
    'chip-filter': type === 'filter'
  }, {
    cross: !iconAfter && type === 'filter'
  }, {
    'chip-selectable': type === 'select'
  }, {
    'chip-selected': props.selected
  }, {
    'font-weight-bold': props.bold
  }, {
    'text-uppercase': props.uppercase
  });

  var tagProps = _objectSpread2(_objectSpread2({}, extraProps), {}, {
    className: className
  });

  var appendIcon = flags.isFilter ? iconAfter || 'cross' : iconAfter;
  return {
    content: props.label || props.children,
    before: makeIcon({
      glyph: iconBefore,
      color: color
    }),
    after: makeIcon({
      glyph: appendIcon,
      color: color,
      align: 'right'
    }),
    flags: flags,
    tagProps: tagProps,
    extraProps: extraProps
  };
}

/* eslint-disable react/jsx-filename-extension */
function Chip(props) {
  var _useChip = useChip(props),
      content = _useChip.content,
      before = _useChip.before,
      after = _useChip.after,
      tagProps = _useChip.tagProps;

  return /*#__PURE__*/React.createElement("span", tagProps, before, content, after);
}
var ChipColors = ['light', 'medium', 'dark'];
var ChipTypes = ['base', 'action', 'filter', 'select'];
var IconNames = ['360', '360-exterior', '360-interior-front', '360-interior-rear', 'alarm-add', 'alarm-clock', 'alarm-set', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'arrows-left-right', 'attach', 'back-to-start', 'barcode', 'bell', 'bell-o', 'blocked', 'bolt', 'bubble', 'bubbles', 'bullet', 'calendar', 'camcorder', 'camera', 'cancel-circle', 'cancel-circle-o', 'car', 'car-side', 'checkbox-checked', 'checkbox-unchecked', 'checkmark', 'checkmark-circle', 'chevron-down', 'chevron-down-chamfered', 'chevron-down-light', 'chevron-left', 'chevron-left-light', 'chevron-right', 'chevron-right-light', 'chevron-up', 'chevron-up-light', 'clipboard', 'clipboard-checked', 'clock', 'cloud-upload', 'condition-report', 'credit-card', 'cross', 'cross-small', 'cup', 'damages', 'details', 'direction', 'disk', 'dollar-o', 'edit', 'enlarge', 'envelope', 'envelope2', 'error-triangle', 'eye', 'eye-blocked', 'file-empty', 'file-excel', 'file-pdf', 'file-spreadsheet', 'file-text', 'files-empty', 'filter', 'fork-spoon', 'fuel', 'gavel', 'gear', 'graph-pie', 'grid', 'grid-small', 'heart', 'heart-o', 'home', 'image', 'images', 'inbox', 'info', 'info-o', 'left-right', 'link', 'list', 'location', 'location-area', 'locked', 'manheim-medallion', 'medal', 'megaphone', 'menu', 'minus', 'minus-circle', 'minus-circle-o', 'minus3', 'mobile', 'new-window', 'notification-circle', 'odometer', 'paint-can', 'paint-drop', 'pause', 'pin', 'pin2', 'play', 'plus', 'plus-circle', 'plus-circle-o', 'printer', 'qr-code', 'refresh', 'reset-time', 'rotate-left', 'rotate-right', 'search', 'shield', 'shield-check', 'shrink', 'sort', 'sound-off', 'sound-on', 'spinner', 'star-empty', 'star-full', 'star-half', 'stopwatch', 'three-dots-horizontal', 'three-dots-vertical', 'thumbs-down', 'thumbs-up', 'trash', 'triangle-down-small', 'triangle-left-small', 'triangle-right-small', 'triangle-up-small', 'triangle-down', 'triangle-left', 'triangle-right', 'triangle-up', 'truck', 'unlink', 'unlocked', 'user', 'user-add', 'users', 'wifi', 'zoom-in', 'zoom-out', 'arrows-up-down', 'profile-ccw-circle-arrow', 'price-tag', 'grounding'];
Chip.propTypes = {
  color: PropTypes.oneOf(ChipColors),
  type: PropTypes.oneOf(ChipTypes),
  label: PropTypes.string,
  transparent: PropTypes.bool,
  actionable: PropTypes.bool,
  selectable: PropTypes.bool,
  selected: PropTypes.bool,
  removeable: PropTypes.bool,
  iconBefore: PropTypes.oneOf(IconNames),
  iconAfter: PropTypes.oneOf(IconNames),
  bold: PropTypes.bool,
  uppercase: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Chip.defaultProps = {
  color: 'medium',
  type: 'base',
  label: null,
  selected: false,
  selectable: false,
  actionable: false,
  removeable: false,
  transparent: false,
  iconBefore: undefined,
  iconAfter: undefined,
  bold: false,
  uppercase: false,
  href: null,
  tabIndex: 0,
  children: null,
  onClick: function onClick() {}
};

export { ChipColors, ChipTypes, IconNames, Chip as default, useChip };
//# sourceMappingURL=index.js.map
